import { useSizes } from '@hg/stylizator/hooks'
import * as React from 'react'

import PromoBannerNoImage from './PromoBannerNoImage'
import PromoBannerWithImage from './PromoBannerWithImage'

export interface PromoBannerProps {
  title: React.ReactNode
  description: React.ReactNode
  buttonText: React.ReactNode
  buttonUrl: string
  image?: string
  variation?: 'small' | 'large'
}

const PromoBanner: React.FC<PromoBannerProps> = ({
  title = 'Earn passive income effortlessly',
  description = (
    <>
      Join Honeygain and collect <b>$2 starter gift</b> for free
    </>
  ),
  buttonText = 'Join Honeygain',
  buttonUrl,
  image,
  variation,
}) => {
  const { isDesktop } = useSizes()
  const hasImage = !!image

  if (hasImage && !isDesktop) {
    return (
      <PromoBannerWithImage
        title={title}
        description={description}
        buttonText={buttonText}
        buttonUrl={buttonUrl}
        variation={variation}
        image={image}
      />
    )
  }

  return (
    <PromoBannerNoImage
      title={title}
      description={description}
      buttonText={buttonText}
      buttonUrl={buttonUrl}
      variation={variation}
    />
  )
}

export default PromoBanner
